import { AppProvider } from "@/app/providers/AppContext.tsx";
import { BriefProvider } from "@/app/providers/BriefContext.tsx";
import { ThemeProvider } from "@/app/providers/ThemeContext.tsx";
import { getProvider } from "@/shared/lib/observability";
import { queryClient } from "@/shared/lib/queryClient";
import { TooltipProvider } from "@/shared/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import "../index.css";
import App from "./App";

// Initialize OpenTelemetry error tracking via the provider abstraction.
// Must run before React renders so auto-instrumentation patches fetch/XHR (M-6).
getProvider().init();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <TooltipProvider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <AppProvider>
              <BriefProvider>
                <App />
                <Toaster position="top-right" richColors theme="dark" />
              </BriefProvider>
            </AppProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </StrictMode>,
);
